module.exports = __webpack_public_path__ + "assets/img/video-thumb-2.cf3cbf24.jpg";